import pkg from '../../package.json';
var version = pkg.version;
export default version;